import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { fetchSubscriptions } from './redux/actions';
import SubscriptionsComponent from './subscriptions-component';

const mapStateToProps = (state: ApplicationState) => ({
  subscriptions: state.devices.detail.subscriptions,
  t: state.i18n.t,
  offset: state.application.offset
});

export default connect(mapStateToProps, {
  fetchSubscriptions
})(SubscriptionsComponent);
